import styled from 'styled-components'

import { Button } from 'components/Button/Button'
import { ActiveMetric } from './Analytics'
import { Switch } from 'components/Switch/Switch'

interface Props {
  activeMetric: ActiveMetric
  onClick: (metric: ActiveMetric) => void
  pnlView: 'pct' | 'usd'
  onPnlViewToggle: () => void
  isLoading: boolean
}

const MetricSetButton = styled(Button)<{ disabled?: boolean }>`
  font-size: 16px;
  padding: 6px 12px;
`

const Container = styled.div`
  padding: 24px;
  padding-bottom: 0px;
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 32px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    flex-wrap: wrap;
    padding: 12px;
    padding-bottom: 0px;
  }
`

export const HeaderControls = ({ activeMetric, onClick, pnlView, onPnlViewToggle, isLoading }: Props) => (
  <Container>
    <MetricSetButton
      outlined={activeMetric !== 'position-size'}
      onClick={() => onClick('position-size')}
      disabled={isLoading}
    >
      Position size
    </MetricSetButton>
    <MetricSetButton outlined={activeMetric !== 'lp-apr'} onClick={() => onClick('lp-apr')} disabled={isLoading}>
      LP APR
    </MetricSetButton>
    <MetricSetButton outlined={activeMetric !== 'apr'} onClick={() => onClick('apr')} disabled={isLoading}>
      APR
    </MetricSetButton>
    <MetricSetButton outlined={activeMetric !== 'pnl'} onClick={() => onClick('pnl')} disabled={isLoading}>
      PnL
    </MetricSetButton>
    <MetricSetButton
      outlined={activeMetric !== 'interest-rates'}
      onClick={() => onClick('interest-rates')}
      disabled={isLoading}
    >
      Interest rates
    </MetricSetButton>
    <MetricSetButton
      outlined={activeMetric !== 'debt-rewards'}
      onClick={() => onClick('debt-rewards')}
      disabled={isLoading}
    >
      Debt/rewards
    </MetricSetButton>
    {activeMetric === 'pnl' && !isLoading && (
      <div style={{ marginLeft: 'auto' }}>
        <Switch checked={pnlView === 'pct'} onChange={onPnlViewToggle} onLabel="%" offLabel="$" />
      </div>
    )}
  </Container>
)
